import { useEffect } from 'react';

interface Options {
  onNew: () => void;
  onClose: () => void;
  onSwitchByIndex: (idx: number) => void;
  /**
   * Nguồn DUY NHẤT để tắt hotkey — do POSPage truyền xuống từ state React.
   *
   * KHÔNG dò DOM (`.ant-modal-wrap` / `.ant-drawer-open`) nữa: rc-dialog dùng
   * Portal `autoDestroy: false`, node `.ant-modal-wrap` Ở LẠI DOM sau khi Modal
   * đóng (real browser chỉ `display:none`, jsdom không có cả dấu hiệu đó). POS
   * mount CustomerDialog thường trực với `destroyOnClose={false}` nên chỉ cần mở
   * dialog khách hàng một lần là selector đó true vĩnh viễn → hotkey chết cả phiên.
   */
  disabled?: boolean;
}

export function usePosTabsHotkeys({
  onNew,
  onClose,
  onSwitchByIndex,
  disabled = false,
}: Options): void {
  useEffect(() => {
    if (disabled) return;
    const handler = (e: KeyboardEvent) => {

      if (e.key === 'F1') {
        e.preventDefault();
        onNew();
        return;
      }
      if (e.key === 'F2') {
        e.preventDefault();
        onClose();
        return;
      }
      if (e.altKey && /^[0-9]$/.test(e.key)) {
        e.preventDefault();
        const n = parseInt(e.key, 10);
        const idx = n === 0 ? -1 : n - 1;
        onSwitchByIndex(idx);
      }
    };
    window.addEventListener('keydown', handler, { capture: true });
    return () => window.removeEventListener('keydown', handler, { capture: true });
  }, [onNew, onClose, onSwitchByIndex, disabled]);
}
